import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryBrowse() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-50">
      <div className="mb-6 md:mb-8">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
          分类浏览
        </h2>
        <p className="text-sm text-foreground-500 mt-1">海量作品，分类细选</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to="/category"
            className="group relative overflow-hidden rounded-lg h-48 md:h-56 cursor-pointer"
          >
            <img
              src={cat.image}
              alt={cat.name}
              title={`${cat.name} - 女神漫画`}
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
              <div className="flex items-center gap-2 mb-1">
                <i className={`${cat.icon} text-white text-lg`}></i>
                <h3 className="text-lg md:text-xl font-heading font-bold text-white">{cat.name}</h3>
              </div>
              <p className="text-white/70 text-sm">{cat.description}</p>
              <p className="text-white/50 text-xs mt-1">{cat.count.toLocaleString()} 部作品</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}